module.exports = __webpack_public_path__ + "static/media/ico_tint_alt_02.fed46827.svg";